import { render } from "./SecondaryNav.vue?vue&type=template&id=1464ff65"
import script from "./SecondaryNav.vue?vue&type=script&lang=js"
export * from "./SecondaryNav.vue?vue&type=script&lang=js"

import "./SecondaryNav.vue?vue&type=style&index=0&id=1464ff65&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__